// src/components/FavoriteListItem.tsx
import React from 'react';
import { Recipe } from '../api/Types'; // Assuming Recipe is still imported from Types
import { Badge, Box, Button, Flex, FlexLink, Heading, ListGroupItem, Text, Thumbnail } from './ui';

interface FavoriteListItemProps {
  recipe: Recipe;
  onRemoveFavorite: (recipeId: string) => Promise<void>;
  disabled?: boolean;
}

const FavoriteListItem: React.FC<FavoriteListItemProps> = ({ recipe, onRemoveFavorite, disabled = false }) => {
  const imageUrl = recipe.image || `${process.env.PUBLIC_URL}/marmite.png`;

  return (
    <Flex as={ListGroupItem} align="center" marginBottom={2} padding={2} background="white" shadow="sm" rounded>
      <FlexLink
        to={`/edit-recipe/${recipe.id}`}
        align="center"
        flexGrow
        textDecoration="none"
        textReset
      >
        <Thumbnail
          src={imageUrl}
          alt={recipe.title}
          marginEnd={3}
          size={60}
        />
        <Box>
            <Heading as="h5" marginBottom={0} textColor="dark">{recipe.title}</Heading>
            {recipe.authors && (
                <Text marginBottom={0} style={{ fontSize: '0.85em', color: recipe.authors.color || undefined }}>
                    Par {recipe.authors.first_name} {recipe.authors.name}
                </Text>
            )}
            {recipe.tags && recipe.tags.length > 0 && (
              <Flex wrap marginTop={1}>
                {recipe.tags.slice(0, 3).map(tag => ( /* Show max 3 tags */
                  <Badge key={tag.id} variant="primary" marginEnd={1} marginBottom={1} style={{ fontSize: '0.7em' }}>
                    {tag.name}
                  </Badge>
                ))}
              </Flex>
            )}
        </Box>
      </FlexLink>
      <Button
        size="sm"
        variant="danger"
        outline
        marginStart="auto"
        onClick={() => {
          void onRemoveFavorite(recipe.id);
        }}
        disabled={disabled}
        title="Retirer des favoris"
      >
        ❤️ Retirer
      </Button>
    </Flex>
  );
};

export default FavoriteListItem;
